import useSWRImmutable from 'swr/immutable'
import { CDN_URL } from '@/utils/constants'
import axios from 'axios'

const fetcher = async (url: string) => {
	const { data } = await axios.get(url)
	return data
}

export default function useInscriptionContent(inscription_id: string) {
	const { data } = useSWRImmutable(`${CDN_URL}/${inscription_id}`, fetcher)

	let content = data
	try {
		content = JSON.parse(data)
	} catch {}

	return content
}
